import { setUserSessionContext } from '@/store/actions';
import { getLocalAccountSession } from '@/utilities/getters/sessionContextGetters';

import { DetachedSessionPayload } from './detached-session';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';

export const applyDetachedSession = (
  _payload: DetachedSessionPayload,
): void => {
  const accountSession = getLocalAccountSession();
  if (!accountSession) return;

  Logger.logRumAction({
    name: '[GW][SESSION][DETACHED] Apply Detached Session',
    useCase: DdEventCategory.Session,
    eventType: DdEventType.Action,
  });

  setUserSessionContext({
    ...accountSession,
    hasActiveSession: true,
  });
};
